/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * StyledSearchField
 *
 * @file StyledSearchField.jsx
 * @author Srinivasan Bakthavatchalam
 * @since 1.0.0
 */

import OutlinedInput from '@material-ui/core/OutlinedInput';
import { withStyles } from '@material-ui/core/styles';

const StyledSearchField = withStyles(theme => ({
  root: {
    background: theme.color.background,
    color: theme.color.textPrimary,
    borderRadius: 'unset',
    border: `1px solid ${theme.color.divider}`,
    fontFamily: 'Hind',
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 'normal',
    height: 42,
    '&:disabled': {
      background: theme.color.toggle
    }
  },
  focused: {
    outline: '0px solid transparent',
    border: `1px solid ${theme.color.activePrimary}`
  },
  disabled: {
    background: theme.color.toggle
  },
  input: {
    height: 42,
    padding: 0
  },
  notchedOutline: {
    border: 'none'
  }
}))(OutlinedInput);

export default StyledSearchField;
